import ApiSmile from '@/api/api-smile';
import PageData from '@/types/page-data';
import LoadingUtil from '@/util/loading-util';
import MessageUtil from '@/util/message-util';
import React, {useEffect, useState} from 'react';
import './fund-list.scss';
import PageParam from '@/types/page-param';
import PageContainer from '@/component/page-container';
import PaginationTable, {ColumnType} from '@/component/pagination-table';
import Utils from '@/util/utils';
import {ProfileOutlined} from '@ant-design/icons';
import {NavigateFunction, useNavigate} from 'react-router';
import {FundData} from '../types';
import ActionArea from '@/component/action-area';
import {ActionButton} from '@/component/action-area/action-area';

const getColumnData = (navigate: NavigateFunction): ColumnType<FundData>[] => {
    const onPressDetail = (record: FundData) => {
        navigate(`/fund/${record.id}`);
    };

    return [
        {
            title: '交易时间',
            dataIndex: 'tradeTime',
            key: 'tradeTime',
            render: (text: number) => Utils.formatDate(text),
        },
        {
            title: '交易金额',
            dataIndex: 'tradeAmount',
            key: 'tradeAmount',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '交易收益',
            dataIndex: 'tradeProfit',
            key: 'tradeProfit',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '资金池余额',
            dataIndex: 'fundPoolBalance',
            key: 'fundPoolBalance',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '累计收益',
            dataIndex: 'totalProfit',
            key: 'totalProfit',
            render: (text: number) => Utils.formatPrice(text),
        },
        {
            title: '描述',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: '详情',
            dataIndex: 'detail',
            key: 'detail',
            render: (_text: string, record: FundData) => (
                <div className="detailIcon" onClick={() => onPressDetail(record)}>
                    <ProfileOutlined />
                </div>
            ),
        },
    ];
};

const FundList = () => {
    const [data, setData] = useState<PageData<FundData>>();
    const [pageParam, setPageParam] = useState<PageParam>({page: 0, size: 10});
    const navigate = useNavigate();

    useEffect(() => {
        const load = async () => {
            LoadingUtil.show();
            const response: any = await ApiSmile.getFundList(pageParam);
            if (response?.data?.code === 0) {
                setData(response.data.data);
            } else {
                const msg = response?.data?.msg || '网络请求失败';
                MessageUtil.error(msg);
            }
            LoadingUtil.hide();
        };

        load();
    }, [pageParam]);

    const onAddClick = () => {
        navigate('/fund/0');
    };

    const getButtons = () => {
        const buttons: ActionButton[] = [
            {
                text: '添加',
                onClick: onAddClick,
            },
        ];
        return buttons;
    };

    return (
        <PageContainer>
            <ActionArea buttons={getButtons()} />
            <PaginationTable columns={getColumnData(navigate)} data={data} setPageParam={setPageParam} />
        </PageContainer>
    );
};

export default FundList;
